export default __webpack_public_path__ + "flag-de-icon.svg";